namespace TabAurous.ECommerce {
    export interface OrderManagementCheckListForm {
        TransItemId: Serenity.StringEditor;
        TransId: Serenity.StringEditor;
        CheckListId: Serenity.IntegerEditor;
        CheckListValue: Serenity.BooleanEditor;
    }

    export class OrderManagementCheckListForm extends Serenity.PrefixedContext {
        static formKey = 'ECommerce.OrderManagementCheckList';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!OrderManagementCheckListForm.init)  {
                OrderManagementCheckListForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.BooleanEditor;

                Q.initFormType(OrderManagementCheckListForm, [
                    'TransItemId', w0,
                    'TransId', w0,
                    'CheckListId', w1,
                    'CheckListValue', w2
                ]);
            }
        }
    }
}
